import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SignupService } from '../services/signup.service';
import { TokenStorage } from '../../core/token.storage';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthorizationService } from '../../common/services/authorization.service';



@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.css']
})
export class PasswordComponent implements OnInit {
constructor(private router: Router, private authService: SignupService, private token: TokenStorage, private toastr: ToastrService) { }
  numSouscript: string;
  //tel: string;
  passwordForm: FormGroup;

    ngOnInit() {
        this.createForm();
    }

    private createForm() {
        this.passwordForm = new FormGroup({
            // tslint:disable-next-line
            numSouscript: new FormControl('', [Validators.required, Validators.pattern('')])
            //tel: new FormControl('', Validators.required)
           
           
        });
    }

    changePassword(): void {

        this.authService.password(this.numSouscript).subscribe(
            (data) => {
                if (data == '2000'){
                    this.token.saveUserID(this.numSouscript);
                
                    this.router.navigate(['validation']);
                    //this.showSuccess();
                   
                }
                else if(data == '1002'){
                    this.router.navigate(['validation']);
                    this.showPhoneError();
                    
                }
                else if(data == '1001'){
                    this.router.navigate(['login']);
                    this.showExistError();
                    
                }
                else{
                    this.router.navigate(['password']);
                    this.showCrossError();
                   
                }
            }, 
            (err) => { 
                //toast.present();
                this.router.navigate(['password']);
                ///console.log("Erreur: ", err);
                this.showCrossError();
            }
            
        ); 
    }

    //
    /*comparePassword(): boolean {
        return (this.password == this.passwordConfirmation);
    }*/

    // For Toatr. 
    showSuccess() {
        this.toastr.success('Mot de passe modifié avec succès, veuillez entrer vos identifiants pour vous connecter! ', 'Modification de mot de passe');
      }



      // For Toatr. 
        showCrossError() {
        this.toastr.error("Une erreur sait produite lors de la modification du mot de passe, veuillez verifier vos informations.", 'Modification de mot de passe');
      }

    
   
    // For Toatr. 
    showPhoneError() {
        this.toastr.success("Vous n'avez pas un numéro de téléphone enregistré auprès de la SONAVIE. Veuillez contacter la SONAVIE pour récupérer votre code de validation.", 'Modification de mot de passe');
      }

     
      showExistError(){
        this.toastr.error("Aucun numéro souscripteur n'est associé à ce compte.", 'Modification de mot de passe');

      }
}



// WEBPACK FOOTER //
// ./src/app/client-app/password/password.component.ts